/**
 * Copyright 2024 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */
import * as styled from 'styled-components';

export const IconButtonContainer = styled.default.div`
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &.disabled {
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.5;
  }
  &.icon-button {
    width: 2.5rem;
    height: 2.5rem;
  }

  svg {
    margin: 0;
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;